import { buildQueryHelpers, OperationIds } from '../../util'
import {
  type CollectionQueryKey,
  type SingleResourceQueryKey,
} from '../../util/types'

export type WorkflowsKey = CollectionQueryKey<OperationIds.ReadWorkflowsV3>

export const readWorkflows = buildQueryHelpers<
  OperationIds.ReadWorkflowsV3,
  WorkflowsKey
>('workflow', OperationIds.ReadWorkflowsV3)

export type WorkflowKey = SingleResourceQueryKey<'ReadWorkflowV3'>

export const readWorkflow = buildQueryHelpers<'ReadWorkflowV3', WorkflowKey>(
  'workflow',
  'ReadWorkflowV3'
)
